module.exports = __webpack_public_path__ + "static/media/cp5.1a69ecbb.png";